import React__default, { useState, useRef } from 'react';
import { useTheme, Box, Collapse, InputAdornment, IconButton, Fade } from '@mui/material';
import { Search } from '@mui/icons-material';
import { ReactComponent as SvgCrossIcon } from '../../../assets/icons/cross-icon.svg.js';
import { ReactComponent as SvgResetIcon } from '../../../assets/icons/reset-icon.svg.js';
import { ZigInputStyled } from './styles.js';
import { useTranslation } from 'react-i18next';

var ZigSearch = function (_a) {
    var value = _a.value, onChange = _a.onChange, id = _a.id, sx = _a.sx;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var inputRef = useRef(null);
    var theme = useTheme();
    var t = useTranslation("zignaly-ui", { keyPrefix: "ZigSearch" }).t;
    return (React__default.createElement(Box, { display: "flex", gap: 2, position: "relative", alignItems: "center", justifyContent: "flex-end", sx: sx },
        React__default.createElement(Collapse, { orientation: "horizontal", in: expanded, timeout: expanded ? 150 : 0 },
            React__default.createElement(Box, { display: "flex", gap: 2, bgcolor: theme.palette.backgrounds.selectInputFill, zIndex: 2, alignItems: "center", width: "309px", height: "56px", position: "relative", borderRadius: "6px", paddingRight: "6px" },
                React__default.createElement(Box, { position: "absolute", width: "100%", height: "100%", p: "6px 45px 6px 6px" },
                    React__default.createElement(ZigInputStyled, { id: id && "".concat(id, "-input"), ref: inputRef, wide: true, value: value, onChange: function (e) {
                            onChange(e.target.value);
                        }, placeholder: t("search"), InputProps: {
                            endAdornment: (React__default.createElement(InputAdornment, { position: "end" },
                                React__default.createElement(IconButton, { sx: {
                                        padding: 0,
                                        height: "24px",
                                        width: "24px",
                                    }, id: id && "".concat(id, "-input-reset") },
                                    React__default.createElement(SvgResetIcon, { onClick: function () { return onChange(""); } })))),
                        } })),
                React__default.createElement(IconButton, { onClick: function () {
                        setExpanded(false);
                        onChange("");
                    }, sx: { height: "32px", width: "32px", marginLeft: "auto" } },
                    React__default.createElement(SvgCrossIcon, { id: id && "".concat(id, "-close"), width: "24px", height: "24px", style: { minHeight: "24px", minWidth: "24px" } })))),
        React__default.createElement(Box, { position: "absolute", right: 0 },
            React__default.createElement(Fade, { in: !expanded },
                React__default.createElement(IconButton, { id: id, onClick: function () {
                        setExpanded(true);
                        setTimeout(function () {
                            var _a;
                            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 100);
                    } },
                    React__default.createElement(Search, null))))));
};

export { ZigSearch as default };
